<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
      <div class="title">请选择座位</div>
    </div>
    <div class="top-center">
      <div class="content">
        <div class="title">影片及场次</div>
        <div class="day">{{day}} {{start_time}}</div>
        <div class="name">
          {{movie_name}}
          <span>￥{{Number(price).toFixed(2)}}/人</span>
        </div>
      </div>
      <!-- 座位选择 -->
      <div class="seat-wrapper">
        <div class="top"></div>
        <div class="line_num_box">
          <span v-for="(item ,index ) in seat_info.seat" :key="index" class="num-wrapper">
            <span class="num">{{index+1}}</span>
          </span>
        </div>
        <div class="seats_item">
          <div
            class="row"
            v-for="(item ,index) in seat_info.seat"
            :key="index"
            :style="{width: rowWidth}"
            :class="'row_'+index"
          >
            <div
              class="icon_seat"
              v-for="(i,sindex) in item"
              :key="sindex"
              @click="handleChooseSeat(index,sindex)"
              :class="'seat_'+(sindex<Math.floor(item.length/2)?sindex%Math.floor(item.length/2):(Math.floor(item.length/2)-sindex%Math.floor(item.length/2))+'r')"
            >
              <span
                class="icon_item iconfont iconzuowei32px"
                v-if="i!=-1"
                :class="i==2?'bought-seat':(i==1?'selected-seat':'unselected-seat')"
              ></span>
              <!--<span v-else-if="i==1" class="icon_item selected-seat"></span>-->
              <!--<span v-else-if="i==0" class="icon_item unselected-seat"></span>-->
              <!--<span v-else-if="i==2" class="icon_item bought-seat"></span>-->
            </div>
          </div>
        </div>
        <!-- 座位提示 -->
        <div class="seat_tips">
          <div class="item">
            <span class="can_text">可选</span>
            <span class="iconfont iconzuowei32px"></span>
          </div>
          <div class="item">
            <span class="can_text">不可选</span>
            <span class="can_item iconfont iconzuowei32px"></span>
          </div>
          <div class="item">
            <span class="can_text">已选</span>
            <span class="iconfont iconzuowei32px selected-seat"></span>
          </div>
        </div>
        <!-- 座位 -->
        <div class="seated">
          <h3>座位</h3>
          <div class="wrapper">
            <span v-for="(item,index) in select_seat" :key="index" class="seat">{{item.seat_name}}</span>
            <p>已选{{select_seat.length}}个座位,还可以选{{select_num-select_seat.length}}个座位</p>
          </div>
        </div>
      </div>
      <div class="btn-group">
        <div class="back-btn" @click="goBack">返回上一步</div>
        <div class="ok" @click="confirm_choose">确认选座</div>
      </div>
    </div>

    <div class="footer">
      <p>
        <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850 25650860</span>
        </span>
      </p>
    </div>
    <div class="mask" v-if="warn!=''">
      <div class="content">
        <div class="icon"></div>
        <p>{{warn}}</p>
      </div>
    </div>
    <div class="back" @click="goBack">退出</div>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import { setInterval, clearInterval, setTimeout } from 'timers'

  export default {
    name: 'HelloWorld',
    data () {
      return {
        warn: '',
        select_num: 6,
        real_seat: [],
        select_seat: [],
        seatStatus: true,
        seat_info: '',
        deviceId: localStorage.deviceNum || '123456789',
        time: '',
        today: '',
        day: '',
        timer: '',
        cur: 0,
        listData: [],
        list: [],
        film_date_layout_id: '',
        movie_name: '',
        price: '',
        start_time: '',
        rowWidth: 'auto',
        warn: ''
      }
    },
    created () {
      this.film_date_layout_id = this.$route.query.film_date_layout_id
      this.movie_name = this.$route.query.name
      this.price = this.$route.query.price
      this.start_time = this.$route.query.time
    },
    mounted () {
      this.getDay()
      this.SeatInfo()
      if (this.timer == '') {
        this.timer = setInterval(() => {
          this.getDay()
        }, 10000)
      }
    },
    destroyed () {
      clearInterval(this.timer)
    },
    methods: {
      goBack () {
        this.$router.replace('/')
      },
      SeatInfo () {
        this.$api.SeatInfo(this.film_date_layout_id).then(res => {
          if (res.status == 1) {
            this.seat_info = res.data
            this.ticket_class_string =
              this.seat_info.ticket_list[0].movie_ticket_class_id + '_'

            let seat = this.seat_info.seat
            let un_seat = this.seat_info.un_seat
            this.week = new Date(res.data.movie_date).getDay()
            for (let k in un_seat) {
              un_seat[k] = un_seat[k].split('_')
            }
            // 判断预留座位和已售出
            for (let i in seat) {
              for (let j in un_seat) {
                if (i == un_seat[j][0]) {
                  for (let m in seat[i]) {
                    if (m == un_seat[j][1]) {
                      seat[i][m] = 2
                    }
                  }
                }
              }
            }
            // 判断实际座位
            let pai = 1
            for (let i in this.seat_info.seat) {
              let zuo = 0
              for (let j in this.seat_info.seat[i]) {
                if (this.seat_info.seat[i][j] == -1) {
                  this.real_seat.push({
                    val: i + '_' + j,
                    seat: ''
                  })
                } else {
                  zuo = zuo + 1
                  this.real_seat.push({
                    val: i + '_' + j,
                    seat: pai + '排' + zuo + '座'
                  })
                }
              }
              if (zuo > 0) {
                pai = pai + 1
              }
            }
          }
        })
      },
      // 选座
      handleChooseSeat (index, sindex) {
        let v = this
        let seatValue = this.seat_info.seat[index][sindex]
        let newArray = this.seat_info.seat
        //如果是已购座位，直接返回
        if (seatValue == 2 || seatValue == -1) return
        let obj = {
          index: index,
          sindex: sindex,
          value: seatValue,
          val: index + '_' + sindex
        }

        if (this.seatStatus) {
          let flag = v.select_seat.some(item => {
            return item.index == index && item.sindex == sindex
          })
          let pos = v.select_seat.findIndex(item => {
            return item.index == index && item.sindex == sindex
          })
          // 如果是已选座位点击后变未选
          if (seatValue == 1 && flag) {
            newArray[index][sindex] = 0
            this.$set(this.seat_info.seat[index], sindex, 0)
            v.select_seat.splice(pos, 1)
          } else if (
            seatValue == 0 &&
            this.select_seat.length < this.select_num &&
            !flag
          ) {
            newArray[index][sindex] = 1
            this.$set(this.seat_info.seat[index], sindex, 1)
            v.select_seat.push(obj)
          } else if (this.select_seat.length == this.select_num) {
            this.overConfrim()
          }
          for (let i in this.real_seat) {
            for (let j in this.select_seat) {
              if (this.real_seat[i].val == this.select_seat[j].val) {
                this.select_seat[j].seat_name = this.real_seat[i].seat
              }
            }
          }
          if (this.select_seat.length > this.select_num) {
            this.seatStatus = false
          }
        } else {
          this.overConfrim()
        }
      },
      // 删除座位
      del_seat (ind, index, sindex) {
        let newArray = this.seat_info.seat
        // 如果是已选座位点击后变未选
        newArray[ind][sindex] = 0
        this.$set(this.seat_info.seat[index], sindex, 0)
        this.select_seat.splice(ind, 1)
      },

      // 确认选座
      confirm_choose () {
        if (this.select_seat.length == 0) {
          this.warn = '请选择座位'
          setTimeout(() => {
            this.warn = ''
          }, 1500)
        } else {
          let seat = ''
          let seat_names = []
          for (let i in this.select_seat) {
            seat += this.select_seat[i].val + '#'
            seat_names.push(this.select_seat[i].seat_name)
          }
          this.ticket_class_string =
            this.ticket_class_string + this.select_seat.length
          this.$api
            .CreateFilmOrder(
              this.film_date_layout_id,
              this.ticket_class_string,
              seat,
              this.select_seat.length
            )
            .then(res => {
              if (res.status == 1) {
                let post = {
                  seat: seat,
                  // seat_num: this.select_seat.length,
                  movie_name: this.seat_info.movie_name,
                  // movie_start_time: this.seat_info.movie_start_time,
                  // movie_end_time: this.seat_info.movie_end_time,
                  address: this.seat_info.address,
                  seat_names: seat_names,
                  movie_date: this.seat_info.movie_date,
                  names: this.names,
                  time: this.start_time,
                  ticket_class_string: this.ticket_class_string,
                  // phone: this.phone,
                  // src: this.movie_info.img,
                  // long_time: this.seat_info.long_time,
                  price_total: res.data.amount
                }
                localStorage.setItem('film_post', JSON.stringify(post))
                this.$router.push({
                  path: '/confirm',
                  query: {
                    orderId: res.data.order_id
                  }
                })
              } else {
                this.warn = res.msg
                setTimeout(() => {
                  this.warn = ''
                }, 1500)
              }
            })
        }
      },
      getDay () {
        var day = new Date()
        var hours = day.getHours()
        hours = hours < 10 ? '0' + hours : hours
        var min = day.getMinutes()
        min = min < 10 ? '0' + min : min
        var month = day.getMonth() + 1
        var days = day.getDate()
        var week = day.getDay()
        var strWeek = ''
        switch (week) {
          case 0:
            strWeek = '星期日'
            break
          case 1:
            strWeek = '星期一'
            break
          case 2:
            strWeek = '星期二'
            break
          case 3:
            strWeek = '星期三'
            break
          case 4:
            strWeek = '星期四'
            break
          case 5:
            strWeek = '星期五'
            break
          case 6:
            strWeek = '星期六'
            break
        }
        this.time = hours + ':' + min
        this.day = month + '月' + days + '日 '
        this.today = month + '月' + days + '日 ' + strWeek
      },
      // 弹出确认超过当前张
      overConfrim () {
        if (this.select_seat.length >= 5) {
          return false
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .container {
    width: 100%;
    min-height: 1920px;
    height: 1920px;
    background: #f0f0f0;
    overflow: hidden;
    position: relative;
    padding-bottom: 165px;

    .top {
      padding: 68px 60px;
      color: #fff;
      background: #005192;
      font-size: 25px;
      height: 486px;
      position: relative;

      h3 {
        font-size: 70px;
        margin: 0;
      }

      .title {
        position: absolute;
        top: 100px;
        left: 55%;
        transform: translateX(-50%);
        font-size: 50px;
        font-weight: 500;
        letter-spacing: 3px;
      }
    }

    .titles {
      font-size: 60px;
      letter-spacing: 3px;
      color: #0c5193;
      text-align: left;
      margin: 85px 60px 50px;
    }

    .top-center {
      padding: 60px;
      margin-top: -300px;
      position: relative;

      .content {
        background: #fff;
        height: 400px;
        position: relative;
        padding: 80px 50px 75px;
        border-radius: 0 0 10px 10px;

        &:after {
          content: "";
          width: 105%;
          height: 0px;
          border: 10px solid #005192;
          border-radius: 5px;
          position: absolute;
          top: -4px;
          left: 50%;
          transform: translateX(-50%);
          box-shadow: 6px 12px 30px #005192;
        }

        .title {
          font-size: 30px;
          color: #838383;
          margin-bottom: 44px;
        }

        .day {
          font-size: 30px;
          color: #005192;
          font-weight: bold;
          margin-bottom: 40px;
        }

        .name {
          font-size: 40px;
          overflow: hidden;
          color: #005192;
          font-weight: bold;
          padding-right: 120px;

          span {
            float: right;
            color: #454545;
          }
        }
      }

      .seat-wrapper {
        margin-top: 50px;
        border: 1px solid #005192;
        border-radius: 6px;
        height: 940px;
        background: #fff;
        position: relative;

        .top {
          position: relative;
          width: 80%;
          height: 80px;
          overflow: hidden;
          margin: 0 auto;
          background: #fff;

          &:after {
            content: "";
            width: 1600px;
            height: 400px;
            border-radius: 50% 50% 0 0/100% 100% 0 0;
            border: 10px solid #3d70b7;
            border-bottom: none;
            position: absolute;
            top: 40px;
            left: 50%;
            -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
          }
        }

        .line_num_box {
          position: absolute;
          top: 95px;
          left: 80px;
          width: 75px;
          height: 100%;

          span.num-wrapper {
            display: block;
            height: 80px;
            line-height: 80px;
            width: 32px;
            text-align: center;

            .num {
              display: inline-block;
              width: 30px;
              height: 30px;
              text-align: center;
              line-height: 30px;
              border-radius: 50%;
              font-size: 20px;
              color: #fff;
              background: #dfdfdf;
              font-weight: 500;
              margin: 8.5px auto;
            }
          }
        }

        .seats_item {
          position: absolute;
          top: 154px;
          left: 150px;
          width: 700px;

          .row {
            padding-bottom: 20px;
            height: 82px;
            position: relative;
            overflow: hidden;

            &:after {
              content: "";
              content: "";
              width: 1600px;
              height: 570px;
              border: 1px dashed #dbdbdc;
              border-radius: 0 0 50% 50% /0 0 100% 100%;
              border-top: none;
              position: absolute;
              bottom: 5px;
              left: 50%;
              -webkit-transform: translateX(-50%);
              transform: translateX(-50%);
              z-index: 1;
            }

            .icon_seat {
              display: inline-block;
              margin: 5px;
              position: absolute;
              bottom: 5px;
              left: 50%;
              z-index: 3;

              &.seat_2r {
                bottom: 35px;
                left: 0;
              }

              &.seat_3r {
                bottom: 30px;
                left: 45px;
              }

              &.seat_1r {
                left: auto;
                bottom: 35px;
                right: 0px;
              }

              &.seat_0 {
                left: auto;
                bottom: 30px;
                right: 45px;
              }

              &.seat_4r {
                bottom: 20px;
                left: 100px;
              }

              &.seat_1 {
                left: auto;
                bottom: 20px;
                right: 100px;
              }

              &.seat_5r {
                bottom: 15px;
                left: 145px;
              }

              &.seat_2 {
                left: auto;
                bottom: 15px;
                right: 145px;
              }

              &.seat_6r {
                bottom: 10px;
                left: 195px;
              }

              &.seat_3 {
                left: auto;
                bottom: 10px;
                right: 195px;
              }

              &.seat_7r {
                bottom: 5px;
                left: 243px;
              }

              &.seat_6 {
                left: 300px;
                bottom: 5px;
              }

              &.seat_4 {
                left: auto;
                bottom: 5px;
                right: 243px;
              }

              .iconfont {
                font-size: 40px;
                color: #dbdbdc;
                cursor: pointer;

                &.bought-seat {
                  color: #e41512;
                  cursor: not-allowed;
                }

                &.selected-seat {
                  color: #6bb52e;
                }
              }
            }
          }

          .row_0 {
            .icon_seat.seat_4r {
              left: 65px;
              bottom: 25px;
            }

            .icon_seat.seat_5r {
              left: 115px;
              bottom: 22px;
            }

            .icon_seat.seat_2 {
              bottom: 25px;
              right: 65px;
            }

            .icon_seat.seat_3 {
              right: 115px;
              bottom: 22px;
            }

            .icon_seat.seat_4 {
              right: 190px;
              bottom: 15px;
            }

            .icon_seat.seat_5 {
              left: auto;
              right: 254px;
            }

            .icon_seat.seat_6 {
              left: 330px;
            }

            .icon_seat.seat_7r {
              left: 265px;
            }
          }

          .row_1 {
            .icon_seat.seat_4r {
              left: 90px;
            }

            .icon_seat.seat_5r {
              left: 155px;
            }

            .icon_seat.seat_6r {
              left: 216px;
            }

            .icon_seat.seat_1 {
              right: 50px;
              bottom: 28px;
            }

            .icon_seat.seat_2 {
              right: 95px;
            }

            .icon_seat.seat_7r {
              left: 255px;
            }

            .icon_seat.seat_4 {
              right: 216px;
            }

            .icon_seat.seat_7r {
              left: 270px;
            }

            .icon_seat.seat_6 {
              left: 328px;
            }

            .icon_seat.seat_5 {
              left: auto;
              right: 270px;
            }

            .icon_seat.seat_3 {
              right: 155px;
            }
          }

          .row_2 {
            .icon_seat.seat_0 {
              right: 16px;
            }

            .icon_seat.seat_1 {
              right: 62.5px;
            }

            .icon_seat.seat_2 {
              right: 122px;
            }

            .icon_seat.seat_3 {
              right: 168.5px;
            }

            .icon_seat.seat_4 {
              right: 230px;
            }

            .icon_seat.seat_6 {
              left: 318px;
            }

            .icon_seat.seat_7r {
              left: 258px;
            }

            .icon_seat.seat_6r {
              left: 212px;
            }

            .icon_seat.seat_5 {
              left: auto;
              right: 275px;
            }
          }

          .row_3,
          .row_4 {
            .icon_seat.seat_4r {
              left: 105px;
            }

            .icon_seat.seat_1 {
              right: 75px;
            }

            .icon_seat.seat_5r {
              left: 150px;
            }

            .icon_seat.seat_2 {
              right: 120px;
            }

            .icon_seat.seat_3 {
              right: 180px;
            }

            .icon_seat.seat_6r {
              left: 210px;
            }

            .icon_seat.seat_7r {
              left: 255px;
            }

            .icon_seat.seat_5 {
              left: auto;
              right: 285px;
            }

            .icon_seat.seat_4 {
              right: 225px;
            }

            .icon_seat.seat_6 {
              left: auto;
              right: 330px;
            }
          }
        }

        .seat_tips {
          position: absolute;
          bottom: 290px;
          left: 0;
          width: 100%;
          text-align: center;

          .item {
            display: inline-block;
            vertical-align: middle;

            &:nth-child(2) {
              margin: 0 50px;
            }

            .iconfont {
              color: #dcdcdc;
              vertical-align: middle;

              &.can_item {
                color: #e41512;
              }

              &.selected-seat {
                color: #6bb52e;
              }

              font-size: 40px;
            }

            .can_text {
              color: #727272;
              display: inline-block;
              font-size: 20px;
              margin-right: 13px;
            }
          }
        }
      }
    }
  }

  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    z-index: 999;
    transition: all ease-in-out 300ms;

    .content {
      width: 600px;
      height: 384px;
      background: #fff;
      border-radius: 6px;
      padding: 65px;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .icon {
        width: 102px;
        height: 102px;
        background: url(.././assets/icon.png) no-repeat;
        background-size: cover;
        margin: 0 auto 80px;
      }

      p {
        color: #5c5c5c;
        font-size: 30px;
        text-align: center;
      }
    }
  }

  .seated {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 30px 60px 30px;
    border-top: 1px dashed #005192;

    &:after {
      content: "";
      width: 16px;
      height: 8px;
      border-radius: 50% 50% 0 0/100% 100% 0 0;
      border: 1px solid #3d70b7;
      position: absolute;
      border-bottom: 0;
      top: -5px;
      left: -6px;
      z-index: 4;
      transform: rotate(90deg);
      background: #e5e5e5;
    }

    &:before {
      content: "";
      width: 16px;
      height: 8px;
      border-radius: 50% 50% 0 0/100% 100% 0 0;
      border: 1px solid #3d70b7;
      position: absolute;
      border-bottom: 0;
      top: -5px;
      right: -6px;
      z-index: 4;
      transform: rotate(-90deg);
      background: #e5e5e5;
    }

    h3 {
      color: #000;
      font-size: 26px;
      margin-bottom: 15px;
    }

    p {
      color: #55555a;
      font-size: 26px;
    }
  }

  .seat {
    width: 158px;
    height: 60px;
    display: inline-block;
    color: #3e70b8;
    font-size: 30px;
    text-align: center;
    line-height: 60px;
    text-align: center;
    background: url(.././assets/seat.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 8px 8px 0;
  }

  .btn-group {
    margin: 40px auto 0;

    .back-btn {
      display: inline-block;
      width: 330px;
      height: 98px;
      border: 1px solid #b95020;
      color: #b95020;
      border-radius: 49px;
      font-size: 30px;
      line-height: 96px;
      text-align: center;
      cursor: pointer;
      margin-right: 57px;
      margin-left: 40px;
    }

    .ok {
      width: 488px;
      height: 98px;
      line-height: 98px;
      background: #b95020;
      color: #fff;
      font-size: 30px;
      border-radius: 49px;
      text-align: center;
      cursor: pointer;
      display: inline-block;
    }
  }

  .back {
    width: 213px;
    height: 98px;
    line-height: 98px;
    box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
    border-radius: 49px 0px 0px 49px;
    background: #fff;
    color: #b95020;
    font-size: 30px;
    text-align: center;
    position: fixed;
    top: 35%;
    right: 0;
    z-index: 998;
    font-weight: 500;
  }

  .footer {
    position: absolute;
    bottom: 0;
    padding: 60px;
    font-size: 24px;
    width: 100%;
    left: 0;

    p {
      color: #5a5a5a;
      font-size: 20px;
      overflow: hidden;
      vertical-align: middle;

      .tel {
        float: right;
        color: #1c78f7;
        font-size: 20px;
        display: inline-block;
        vertical-align: middle;

        span {
          margin-left: 10px;
          font-size: 34px;
          font-weight: 800;
          vertical-align: middle;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Seat.vue